// import React from "react";
// import { Navigate, useLocation } from "react-router-dom";
// import { useSelector } from "react-redux";

// const AuthenticateRouter = ({ children }) => {
//   const location = useLocation();
//   const currentPathName = location?.pathname;
//   const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
//   // const localStorageLoggedStatus = JSON.parse(
//   //   localStorage.getItem("isLoggedIn")
//   // );

//   const { menu_list } = useSelector((x) => x?.auth);

//   const checkPathExists = (pathname) => {
//     return menu_list?.some(
//       (menuItem) =>
//         menuItem.URLPath === pathname ||
//         menuItem?.SubMenus?.some((subMenu) => subMenu.Subpath === pathname)
//     );
//   };
//   return isLoggedIn &&
//     (currentPathName !== "/Admin/support" &&
//     currentPathName !== "/Admin/ChangePassword" &&
//     currentPathName !== "/Admin/Maintenance"
//       ? checkPathExists(currentPathName)
//       : true) ? (
//     children
//   ) : isLoggedIn ? (
//     <Navigate to="/Admin/Maintenance" replace />
//   ) : (
//     <Navigate to="/ddd" replace />
//   );
// };

// export default AuthenticateRouter;

import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const AuthenticateRouter = ({ children }) => {
  const location = useLocation();
  //   const currentPathName = location?.pathname;
  // const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const isLoggedIn = sessionStorage.getItem("isLoggedIn");

  // If you want to check session storage instead of redux state:
  // const sessionStorageLoggedStatus = JSON.parse(
  //   sessionStorage.getItem("isLoggedIn")
  // );

  //   const { menu_list } = useSelector((x) => x?.auth);

  //   const checkPathExists = (pathname) => {
  //     return menu_list?.some(
  //       (menuItem) =>
  //         menuItem.URLPath === pathname ||
  //         menuItem?.SubMenus?.some((subMenu) => subMenu.Subpath === pathname)
  //     );
  //   };

  return isLoggedIn && true ? children : <Navigate to="/Admin/login" replace />;
};

export default AuthenticateRouter;
